"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareConfirmationBanner = void 0;
var _materialSymbols = require("@design/icons/material-symbols");
var _jsxRuntime = require("react/jsx-runtime");
var ShareConfirmationBanner = exports.ShareConfirmationBanner = function ShareConfirmationBanner(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    role: "status",
    className: "inline-flex max-w-full items-center gap-2 rounded-2xl px-2 py-1 text-xs text-success-text",
    "data-sentry-component": "ShareConfirmationBanner",
    "data-sentry-source-file": "share-confirmation-banner.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckCircleIcon, {
      className: "shrink-0",
      "data-sentry-element": "CheckCircleIcon",
      "data-sentry-source-file": "share-confirmation-banner.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "truncate",
      children: message
    })]
  });
};